import { Tag } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import "Benchmarking/Scss/FacultyCard.scss";

const FacultyCard = ({ data, compareList, setCompareList }) => {
  const navigate = useNavigate();

  const handleOpenDrawer = () => {
    navigate(`/benchmarking/faculty/profile/${data.id}`);

    // setOpen(true);
    // getFacultyBaseStatisticById(data.id, (res) => {
    //   const citation_statistic = Object.keys(res.citation_by_publish_year).map(
    //     (key) => {
    //       return {
    //         Year: key,
    //         Citations: res.citation_by_publish_year[key],
    //       };
    //     }
    //   );
    //   setBaseStat({
    //     ...res,
    //     citation_by_year: citation_statistic,
    //   });
    // });
    // getFacultyAdvanceStatisticById(data.id, (res) => {
    //   setAdvanceStat(res);
    // });
    // getConceptMapById(data.id, null, null, null, null, (res) => {
    //   setConceptMap(res.keywords);
    // });
  };
  return (
    <div
      className="faculty-card-profile"
      style={{
        boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.15)",
        // border: "1px solid var(--benchmarking-color)",
        padding: "10px",
        borderRadius: "10px",
      }}
    >
      <div
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.preventDefault();
          handleOpenDrawer();
        }}
      >
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ position: "relative", width: "40px", height: "40px" }}>
            <img
              src={
                data.photo
                  ? data.photo
                  : "https://scholar.google.com/citations/images/avatar_scholar_256.png"
              }
              alt="avatar"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            <svg
              style={{
                width: "18px",
                height: "18px",
                position: "absolute",
                right: -3,
                bottom: -3,
              }}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.592 9.46049C16.8463 9.13353 16.7874 8.66232 16.4605 8.40802C16.1335 8.15372 15.6623 8.21262 15.408 8.53958L11.401 13.6914C11.3119 13.806 11.1443 13.8209 11.0364 13.7238L8.50173 11.4426C8.19385 11.1655 7.71963 11.1904 7.44254 11.4983C7.16544 11.8062 7.1904 12.2804 7.49828 12.5575L10.033 14.8387C10.7881 15.5183 11.9613 15.4143 12.585 14.6123L16.592 9.46049Z"
                fill="var(--benchmarking-color)"
              />
            </svg>
          </div>
          <div style={{ marginLeft: "15px" }}>
            <p style={{ fontWeight: "600" }}>{data.name}</p>
            <div className="position">
              <p style={{ fontSize: "12px", color: "var(--dark-grey)" }}>
                {data.position}
              </p>
            </div>
          </div>
        </div>
        <p style={{ fontWeight: "600" }}>{data.department.inst_name}</p>
        <div style={{ marginTop: "10px" }}>
          {data.keywords.slice(0, 3).map((item, index) => {
            return (
              <Tag key={index} color="var(--light-blue)">
                {item.value}
              </Tag>
            );
          })}
          <Tag key={4} color="var(--light-blue)">
            +{data.keywords.length - 3}
          </Tag>
        </div>
      </div>
      {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Tooltip title="See more information">
          <svg
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
            }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="faculty-info-button"
          >
            <path
              d="M12 8V9M12 11.5V16M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="faculty-info-path"
            />
          </svg>
        </Tooltip>
        <Tooltip
          title={
            compareList.some((item) => item.id === data.id)
              ? "Already on list"
              : "Add to compare"
          }
        >
          <svg
            onClick={handleAddCompare}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={
              compareList.some((item) => item.id === data.id)
                ? "no-add"
                : "add-compare-button"
            }
          >
            <path
              d="M12 8V16M16 12H8M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="add-compare-path"
            />
          </svg>
        </Tooltip>
      </div> */}
    </div>
  );
};

export default FacultyCard;
